import controller from './file-preview-modal.controller';
import template from './file-preview-modal.html';
import './file-preview-modal.scss';

/**
 * @param {any} resolve
 * @returns {any}
 */
export default ({ resolve }) => ({
	template,
	resolve,
	controller,
	controllerAs: '$ctrl',
	size: 'full',
	windowClass: 'modal-file-preview',
});
